import React from 'react';
import './styles.css';

const SambutanKepsek = ({ content }) => {
    // Skeleton UI saat data sedang dimuat atau belum tersedia
    if (!content) {
        return (
            <section className="section">
                <div className="container">
                    <h2>Sambutan Kepala Sekolah</h2>
                    <div className="sambutan-content">
                        <div className="skeleton skeleton-image kepsek-image"></div>
                        <div className="sambutan-text-wrapper">
                            <div className="skeleton skeleton-text"></div>
                            <div className="skeleton skeleton-text"></div>
                            <div className="skeleton skeleton-text" style={{ width: '80%' }}></div>
                            <div className="kepsek-signature" style={{ marginTop: '40px' }}>
                                <div className="skeleton skeleton-text" style={{ width: '150px', height: '24px' }}></div>
                                <div className="skeleton skeleton-text" style={{ width: '200px', marginTop: '8px' }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    const { 
        sambutan_text,
        sambutan_imageUrl,
        sambutan_nama,
        sambutan_jabatan
    } = content || {};

  return (
    <section className="section">
      <div className="container">
        <h2>Sambutan Kepala Sekolah</h2>
        <div className="sambutan-content">
          <img 
            src={sambutan_imageUrl || "https://via.placeholder.com/300x400.png?text=Foto+Kepala+Sekolah"} 
            alt={sambutan_nama || "Kepala Sekolah"} 
            className="kepsek-image" 
          />
          <div className="sambutan-text-wrapper">
            <div className="sambutan-text" dangerouslySetInnerHTML={{ __html: sambutan_text?.replace(/\n/g, '<br />') || "<p>Sambutan belum diatur.</p>"}} />
            <div className="kepsek-signature">
                <p className="kepsek-name">{sambutan_nama || 'Nama Kepala Sekolah'}</p>
                <p className="kepsek-role">{sambutan_jabatan || 'Kepala Sekolah SMK Pariwisata Sumbangsih'}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default SambutanKepsek;